export default "__VITE_ASSET__BVQwZH2n__"